<template>
  <TableBodyRow
    :thead="thead"
    class="combosrow gw_table_body_row_hoverables"
  >
    <TableBodyCell
      thKey="player"
      class="gw_table_body_cell_sticky"
    >
      <span
        style="position: absolute"
        class="text-nowrap"
      >
        <span class="weight_700">
          {{ getPlayerHtmlPosition(item.position) || '-' }}
          <i
            v-if="item.is_hero"
            class="mdi mdi-crown"
          />
        </span>
      </span>
    </TableBodyCell>

    <TableBodyCell
      :class="item.ev_css_class"
      thKey="ev"
    >
      <StudyPlayersTableRowBox :class="item.ev_css_class">
        <span
          v-html="
            getEvHtml({
              ...bettingInfo,
              ev: item.total_ev,
              player: item.is_hero ? 'hero' : 'opponent',
            })
          "
        />
      </StudyPlayersTableRowBox>
    </TableBodyCell>
    <TableBodyCell
      :class="item.eq_css_class"
      thKey="equity"
    >
      <StudyPlayersTableRowBox :class="item.eq_css_class">
        {{ numFixedUnit((item.total_eq || 0) * 100, 'eq') }} %
      </StudyPlayersTableRowBox>
    </TableBodyCell>
    <TableBodyCell
      :class="item.eqr_css_class"
      thKey="eqr"
    >
      <StudyPlayersTableRowBox :class="item.eqr_css_class">
        {{ numFixedUnit((item.total_eqr || 0) * 100, 'eqr') }} %
      </StudyPlayersTableRowBox>
    </TableBodyCell>

    <TableBodyCell
      v-if="hasCombos"
      :class="item.combos_css_class"
      thKey="combos"
    >
      <StudyPlayersTableRowBox :class="item.combos_css_class">
        {{ numFixedUnit(item.total_combos, 'combos') }}
      </StudyPlayersTableRowBox>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

import StudyPlayersTableRowBox from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTableRowBox'

export default {
  name: 'StudyPlayersTableRow',

  components: {
    TableBodyRow,
    TableBodyCell,
    StudyPlayersTableRowBox,
  },
  mixins: [table_mix, float_mix],
  props: {
    thead: Object,
    item: Object,
    index: Number,
    hasCombos: { type: Boolean, default: true },
    bettingInfo: Object,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.td_icon {
  margin-left: -0.25rem;
  margin-right: 0.125rem;
}
.td {
  &_value {
    &_up {
      color: var(--clr-primary);
      .td_icon {
        color: var(--clr-primary);
      }
    }
    &_down {
      color: var(--clr-error);
      .td_icon {
        transform: rotate(180deg);
        color: var(--clr-error);
      }
    }
  }
}
</style>
